import { gql } from "@apollo/client";

// Payroll export (wfc-server PayrollResolver): settings + the packages it can write files for,
// the period's check (who's ready, who needs fixing), making the file, and past exports.

export const payrollSettingsQuery = gql`
  query PayrollSettings {
    payrollSettings { message response }
  }
`;

export const setPayrollSettingsMutation = gql`
  mutation SetPayrollSettings($input: JSON!) {
    setPayrollSettings(input: $input) { message response }
  }
`;

export const payrollPreviewQuery = gql`
  query PayrollPreview($input: PayrollPeriodInput!) {
    payrollPreview(input: $input) { message response }
  }
`;

export const exportPayrollMutation = gql`
  mutation ExportPayroll($input: PayrollExportInput!) {
    exportPayroll(input: $input) { message response }
  }
`;

export const payrollExportsQuery = gql`
  query PayrollExports {
    payrollExports { message response }
  }
`;

export const payrollExportQuery = gql`
  query PayrollExport($id: String!) {
    payrollExport(id: $id) { message response }
  }
`;

// employees paid below the minimum wage last month / this month - the whole company (dashboard,
// Employees list) or one employee (their data quality)
export const payrollMinimumWageQuery = gql`
  query PayrollMinimumWage($employeeId: String) {
    payrollMinimumWage(employeeId: $employeeId) { message response }
  }
`;

// an employee's Calendar: whether each duty's pay has been calculated, and what it came to
export const employeeDutyPayQuery = gql`
  query EmployeeDutyPay($employeeId: String!, $from: String!, $to: String!) {
    employeeDutyPay(employeeId: $employeeId, from: $from, to: $to) { message response }
  }
`;

// unlock a duty paid in payroll so it can be corrected (Reports modify, reason required)
export const reopenPaidDutyMutation = gql`
  mutation ReopenPaidDuty($scheduleId: String!, $reason: String!) {
    reopenPaidDuty(scheduleId: $scheduleId, reason: $reason) { message response }
  }
`;
